import type { VoidFunctionComponent } from 'react';

import { useReportFlow } from '../hooks/useReportFlow';

import { CustomOptions } from './CustomOptions';
import { StandardOptions } from './StandardOptions';

type ReportOptionsProps = {
  onSavedOptionsApply?: () => void;
};

/**
 * The main component which renders the report options.
 * It is aware of the report flow (standard vs custom) and renders the appropriate options.
 */
export const ReportOptions: VoidFunctionComponent<ReportOptionsProps> = ({ onSavedOptionsApply }) => {
  const [flow] = useReportFlow();
  return flow === 'custom' ? <CustomOptions onSavedOptionsApply={onSavedOptionsApply} /> : <StandardOptions />;
};
